const root = 'listFiltersBar'

export const TestId = {
  label: `${root}-label`,
}
